import ActivityList from './activity-list';
import routes from './activity-routes';
import store from './activity-store';

const components = [ActivityList];

export default {
  routes,
  components,
  store,
};



// WEBPACK FOOTER //
// ./src/activity/activity-module.js